@if (tableSource.data.length > 0) {
  <table
    mat-table
    *ngIf="tableSource?.data?.length && displayedColumns?.length"
    [dataSource]="tableSource"
    class="mat-elevation-z8"
    multiTemplateDataRows
  >
    <!-- 🧭 Coluna: Nome do módulo -->
    <ng-container matColumnDef="modulo">
      <th mat-header-cell *matHeaderCellDef>Módulo</th>
      <td mat-cell *matCellDef="let element">
        {{ element.modulo }}
      </td>
    </ng-container>

    <!-- 🔢 Coluna: Quantidade de Ações -->
    <ng-container matColumnDef="total_acoes">
      <th mat-header-cell *matHeaderCellDef>Qtd Ações</th>
      <td mat-cell *matCellDef="let element">
        {{ element.acoes?.length || 0 }}
      </td>
    </ng-container>

    <!-- 📊 Coluna: Status do Módulo -->
    <ng-container matColumnDef="status_modulo">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center justify-between gap-2">
          <span>{{ getModuleStatus(element) }}</span>
          <button
            [ngClass]="
              isModuleFullyGranted(element)
                ? 'btn-disable-sm'
                : 'btn-enable-sm'
            "
            (click)="updateModulePermission(element); $event.stopPropagation()"
            [disabled]="!element.acoes || element.acoes.length === 0"
          >
            {{ isModuleFullyGranted(element) ? 'Revogar Todas' : 'Conceder Todas' }}
          </button>
        </div>
      </td>
    </ng-container>

    <!-- ⬇️ Coluna: Expansão -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div
          class="cursor-pointer"
          (click)="
            expandedElement = expandedElement === element ? null : element;
            $event.stopPropagation()
          "
        >
          <mat-icon>
            {{ expandedElement === element ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </mat-icon>
        </div>
      </td>
    </ng-container>

    <!-- 📂 Linha expandida: Ações -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        class="p-0"
      >
        <div
          class="table-detail"
          [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
        >
          <div class="sub-table">
            <div class="subt-header">
              <span class="st-id">ID</span>
              <span class="st-func">Ação</span>
              <span class="st-hab">Status</span>
              <span class="st-action">Ação</span>
            </div>

            @for (acao of element.acoes; track acao.id_crud) {
              <div class="subt-item">
                <span class="st-id">{{ acao.id_crud }}</span>
                <span class="st-func">{{ acao.descricao }}</span>
                <span class="st-hab">
                  {{ acao.tem_permissao === 1 ? 'Permitido' : 'Não Permitido' }}
                </span>
                <span class="st-action">
                  <button
                    [ngClass]="
                      acao.tem_permissao === 1
                        ? 'btn-disable'
                        : 'btn-enable'
                    "
                    (click)="updatePermission(acao, element)"
                  >
                    {{ acao.tem_permissao === 1 ? 'Revogar' : 'Conceder' }}
                  </button>
                </span>
              </div>
            }
          </div>
        </div>
      </td>
    </ng-container>

    <!-- 🧾 Cabeçalho principal -->
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>

    <!-- 📋 Linha principal (módulo) -->
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
      [class.example-expanded-row]="expandedElement == row"
      (click)="expandedElement = expandedElement == row ? null : row"
    ></tr>

    <!-- 🔽 Linha expandida -->
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="example-detail-row"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}
